import React, { Component } from 'react';
import SignInSide from './SignInSide';


class Logout extends Component {
    constructor(props) {
        super(props);
        localStorage.removeItem("token")
        localStorage.removeItem("Admin1token")
    }

  
    render() {

          
        return (
           
           <SignInSide/>
        );
    }
}


export default Logout;